import { ApiService } from '../ApiService';
import { Comment } from '../../models/Comment';
import { MembersView } from '~/models/Member';
import { plainToClass } from '~/models/transform';
import { BaseListRequestParams } from '~/models/BaseRequestParams';

export class CommentsService {
  static async likeComment(comment: Comment): Promise<any> {
    const endpoint = `comments/${comment.Id}/like`;
    return ApiService.post(endpoint, {});
  }

  static async unlikeComment(comment: Comment): Promise<any> {
    const endpoint = `comments/${comment.Id}/unlike`;
    return ApiService.post(endpoint, {});
  }

  static async getLikes(comment: Comment, params?: BaseListRequestParams): Promise<MembersView> {
    const response = await ApiService.get<MembersView>(`comments/${comment.Id}/likes`, params);
    return plainToClass(MembersView, response);
  }

  static async deleteComment(commentId: number): Promise<void> {
    const endpoint = `comments/${commentId}`;
    await ApiService.delete(endpoint);
  }

  static async editComment(commentId: number, text: string): Promise<Comment> {
    const endpoint = `comments/${commentId}`;
    const response = await ApiService.patch<Comment>(endpoint, { Text: text });
    return plainToClass(Comment, response);
  }
}